import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../../../shared/Header/Header';
import imprivataIcon from '../Icons/imprivata.svg';
import lock from '../Icons/lock.svg';
import './HelpdeskVerificationResult.scss';

/**
 * HelpdeskVerificationResult prompt
 * @class HelpdeskVerificationResult
 * @extends {Component}
 */
class HelpdeskVerificationResult extends Component {

  static propTypes = {
    /** Header title */
    headerTitle: PropTypes.string,
    /** The component to be used for logout */
    logoutComponent: PropTypes.object,
    /** The DOM tree/component to be used for the footer */
    footer: PropTypes.object,
    /** The result of the helpdesk verification */
    helpdeskVerificationResult: PropTypes.string,
    /** The details of the helpdesk verification */
    helpdeskVerificationDetails: PropTypes.string,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };
  static defaultProps = {
    headerTitle: 'Verify identity',
    logoutComponent: null,
    helpdeskVerificationResult: 'Your identity has been verified.',
    helpdeskVerificationDetails: 'You may close this window.',
    // Parkland custom UX
    useCustomUX: false,
  };

  render() {
    return (
      <div className='CIDRA'>
        {this.props.useCustomUX ?
          (<Header />)
          :
          (
            <div className='Header-Box'>
              <img src={lock} className='Modality-Icon' alt='lock' />
              <div className='Header-Text'>
                <span>{this.props.headerTitle}</span>
              </div>
            </div>
          )
        }
        <div className='login-container'>
          <div className='result-content'>
            <div className='message-container'>
              <div className='message-result'>{this.props.helpdeskVerificationResult}</div>
              <div className='message-details'>{this.props.helpdeskVerificationDetails}</div>
            </div>
          </div>
        </div>
        <hr className='Footer-hr' />
        <img className='Footer' src={imprivataIcon} alt='logo' />
      </div>
    );
  }
}

export default HelpdeskVerificationResult;
